import React, { useEffect } from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';

import Typography from '@material-ui/core/Typography';
// import history from 'utils/history';
import ken42Logo from '../../Assets/Ken42logo.png';
import { makeStyles } from '@material-ui/core/styles';
import LoginImage from '../../Assets/startImage.jpg';
import context from '../../Utils/context';
import clsx from 'clsx';

//authentication imports
import GoogleLogin from 'react-google-login';
import { useTranslation } from 'react-i18next';
import { useHistory, withRouter } from 'react-router';
import KenSnackBar from '../../Components/KenSnackbar';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
    [theme.breakpoints.only('xs')]: {
      background: '#E5E5E5;',
    },
  },

  image: {
    backgroundImage: `url(${LoginImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light'
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    [theme.breakpoints.only('xs')]: {
      height: '65%',
    },
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    paddingLeft: '20%',
    paddingRight: '20%',
    [theme.breakpoints.only('xs')]: {
      paddingLeft: '10%',
      paddingRight: '10%',
    },
  },
  submit: {
    align: 'center',
    margin: theme.spacing(3, 0, 2),
  },
  overlay: {
    // position: 'relative',
    // top: '0',
    // left: '0',
    width: '100%',
    height: '100%',
    background: 'rgba(0,0,0,0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  textFacultyPortal: {
    marginTop: '8px !important',
    fontSize: '28px !important',
    // lineHeight: '28px',
    textAlign: 'center',
    color: theme.palette.KenColors.neutral100,
    fontWeight: '300',
    letterSpacing: '0.14em',
  },
  signInText: {
    fontWeight: '600',
    fontSize: '28px',
    lineHeight: '28px',
    textAlign: 'center',
    color: theme.palette.KenColors.neutral900,
    letterSpacing: '0.14em',
  },
  textCenter: {
    marginTop: '250px',
  },
  fontStyleA: {
    fontWeight: '800 !important',
    fontSize: '48px !important',
    textAlign: 'center',
    color: theme.palette.KenColors.kenWhite,
    [theme.breakpoints.only('xs')]: {
      fontSize: '28px',
    },
  },
  buttonDiv: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '8px',
    marginTop: '8px',
  },
  powerBy: {
    color: theme.palette.KenColors.neutral100,
    fontSize: '10px !important',
    marginBottom: '8px !important',
  },
  hide: {
    display: 'none',
  },
  circular: {
    paddingTop: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  AbsolutePosition: {
    padding: '40px',
    [theme.breakpoints.only('xs')]: {
      position: 'absolute',
      top: '47%',
      background: theme.palette.KenColors.kenWhite,
      width: '90%',
      height: '70%',
      marginLeft: '5%',
      marginRight: '5%',
      borderRadius: '3px',
    },
  },
  logoWrap: {
    marginTop: '-16% !important',
    minHeight: '300px',
    [theme.breakpoints.down('xs')]: {
      marginTop: '0 !important',
      minHeight: 0,
    },
  },
  signInWrap: {
    margin: '0 !important',
  },
  powerByImage: {
    height: '50px',
  },
  poweredByGrid: {
    // position: 'absolute',
    // bottom: '100px',
    // [theme.breakpoints.down('sm')]: {
    //   position: 'relative',
    //   bottom: 0,
    // },
  },
  titleGrid: {
    minHeight: '233px',
    [theme.breakpoints.down('xs')]: {
      minHeight: 0,
    },
  },
}));

function LoginPage(props) {
  const { t } = useTranslation();
  const { handleSnackbarOpen, config } = React.useContext(context);
  const history = useHistory();
  const classes = useStyles();
  const [progress, setProgress] = React.useState(false);
  //for global snackbar
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const [snackbarMessage, setSnackbarMessage] = React.useState('');

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };

  // const handleSnackbarOpen = (severity, message) => {
  //   setOpenSnackbar(true);
  //   setSnackbarSeverity(severity);
  //   setSnackbarMessage(message);
  // };

  const responseGoogle = (response) => {
    console.log('response from Google Auth', response);
    if (response?.profileObj?.email) {
      const isAuthorizedUser = config?.login?.authorizedUsers?.some(
        (el) => el.email === response.profileObj.email
      );
      if (isAuthorizedUser) {
        localStorage.setItem('loggedIn', true);
        history.push('/app/current-programmes');
      } else {
        alert('Unauthorized user, Access denied!');
      }
    } else {
      // handleSnackbarOpen('error', 'Login Failed, Please try again');
    }
  };
  const tempLogin = () => {
    localStorage.setItem('loggedIn', true);
    history.push('/app/current-programmes');
    handleSnackbarOpen('success', 'Login Success');
  };

  return (
    <Grid
      container
      component="main"
      className={classes.root}
      data-testid="login-page"
    >
      <CssBaseline />

      <Grid item xs={12} sm={6} md={6} className={classes.image}>
        <Box className={classes.overlay}>
          <Grid>
            {config?.clientlogo === undefined ||
              config?.clientlogo === null ? null : (
              <Grid style={{ textAlign: 'center' }}>
                <img
                  alt="logo"
                  src={config?.clientlogo}
                  style={{ width: '100px', marginTop: '-48%' }}
                />
              </Grid>
            )}
            <Box>
              <Typography className={classes.fontStyleA}>
                {t('login:sideHeading1')}
              </Typography>
              <Typography className={classes.fontStyleA}>
                {t('login:sideHeading2')}
              </Typography>
            </Box>
          </Grid>
        </Box>
      </Grid>

      <Grid
        item
        xs={12}
        sm={6}
        md={6}
        container
        direction="column"
        justify="space-around"
        alignItems="center"
        elevation={6}
        className={classes.AbsolutePosition}
      >
        <Grid item className={classes.titleGrid}>
          <Typography
            className={classes.textFacultyPortal}
            data-testid="portal-title"
          >
            {t('login:portal')}
          </Typography>
        </Grid>
        <Grid
          item
          className={config?.logo ? classes.logoWrap : classes.signInWrap}
          data-testid="client-logo"
        >
          {config?.logo === undefined || config?.logo === null ? null : (
            <img alt="logo" src={config?.logo} style={{ height: 100 }} />
          )}

          <>
            <div className={classes.buttonDiv} data-testid="login-button">
              <div>
                {config?.google?.clientId && (
                  <GoogleLogin
                    clientId={config?.google?.clientId}
                    redirectUri={config?.google?.redirectUri}
                    render={(renderProps) => (
                      <Button
                        variant="contained"
                        color="primary"
                        className={clsx(classes.buttonDiv, {
                          [classes.hide]: progress,
                        })}
                        onClick={tempLogin} //renderProps.onClick
                      // disabled={renderProps.disabled}
                      >
                        {t('login:Sign_In')}
                      </Button>
                    )}
                    onSuccess={responseGoogle}
                    onFailure={responseGoogle}
                    cookiePolicy={config?.google?.cookiePolicy}
                  />
                )}
                <Button
                  variant="contained"
                  color="primary"
                  className={clsx(classes.buttonDiv, {
                    [classes.hide]: progress,
                  })}
                  onClick={tempLogin} //renderProps.onClick
                // disabled={renderProps.disabled}
                >
                  {t('login:Sign_In')}
                </Button>
              </div>
            </div>
            <div
              className={clsx(classes.buttonDiv, {
                [classes.hide]: !progress,
              })}
            ></div>
          </>
        </Grid>
        <Grid item className={classes.poweredByGrid}>
          <Box mb={2} textAlign="center">
            <Typography
              className={classes.powerBy}
              data-testid="powered-by-text"
            >
              {t('Powered_By')}
            </Typography>
            <Typography>
              <img
                alt="logo"
                src={ken42Logo}
                className={classes.powerByImage}
                data-testid="powered-by-image"
              />
            </Typography>
          </Box>
          <KenSnackBar
            message={snackbarMessage}
            severity={snackbarSeverity}
            autoHideDuration={4000}
            open={openSnackbar}
            handleSnackbarClose={handleSnackbarClose}
            position="Bottom-Right"
          />
        </Grid>
      </Grid>
    </Grid>
  );
}
export default withRouter(LoginPage);
